// WARNING: This file is copied verbatim from webcomponents elements-forms. Do not export in index.

import "@polymer/polymer/lib/elements/dom-if.js";
import "@polymer/iron-form/iron-form.js";

/**
 * Extends the iron-form element, allowing functionality to be added.
 */
const IronForm = customElements.get("iron-form");

export class NsFormTemp extends IronForm {
  static get is() {
    return "ns-form-temp";
  }

  ready() {
    super.ready();
  }
}

customElements.define(NsFormTemp.is, NsFormTemp);
